import { metrics, testimonials } from '@/mocks/heiliao';

const principles = [
  {
    icon: 'ri-shield-check-line',
    title: '只整理公开信息',
    desc: '收录可回溯的公开内容，不发布未经证实的指控，也不对真实个人做评价性结论。',
  },
  {
    icon: 'ri-node-tree',
    title: '分类先于排序',
    desc: '先用分区与标签把话题归档，再谈热度，让同一件事可以从不同路径被找到。',
  },
  {
    icon: 'ri-refresh-line',
    title: '持续复核修订',
    desc: '编辑团队按栏目定期复核，过时或已被更正的信息会归档并标注更新说明。',
  },
];

export default function AboutSection() {
  return (
    <section id="about" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1400px] px-4 md:px-8">
        <div className="reveal grid grid-cols-1 gap-10 lg:grid-cols-[1.1fr_1fr] lg:items-center">
          <div>
            <span className="text-xs font-semibold tracking-[0.3em] text-primary-600">ABOUT US</span>
            <h2 className="mt-2 font-heading text-2xl font-black text-foreground-950 md:text-4xl">
              关于 44黑料区
            </h2>
            <p className="mt-5 text-sm leading-7 text-foreground-700">
              44黑料区是一个以目录方式整理娱乐舆论话题的内容导航站。我们相信，很多困扰并不是"信息太少"，
              而是"信息太乱"。与其让你在无穷的信息流里翻找，不如先把话题按明星、网红、政商、社会等标签分区归档，
              再提供清晰的目录与导航索引。
            </p>
            <p className="mt-4 text-sm leading-7 text-foreground-700">
              我们不生产爆料，也不为任何立场背书。这里做的是"整理"这件事本身：把公开可见的内容按结构与时间线
              放好，让读者自己判断、自己选择要看什么。
            </p>

            <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-5 border-t border-background-300 pt-6 sm:grid-cols-4">
              {metrics.map((item) => (
                <div key={item.label}>
                  <dt className="font-heading text-2xl font-black text-primary-600">{item.value}</dt>
                  <dd className="mt-1 text-xs text-foreground-600">{item.label}</dd>
                </div>
              ))}
            </dl>
          </div>

          <div className="grid grid-cols-1 gap-4">
            {principles.map((p) => (
              <div
                key={p.title}
                className="flex gap-4 rounded-lg border border-background-300 bg-background-100 p-5"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-primary-50 text-primary-600">
                  <i className={`${p.icon} text-xl`}></i>
                </span>
                <div>
                  <h3 className="font-heading text-base font-bold text-foreground-950">{p.title}</h3>
                  <p className="mt-1.5 text-xs leading-relaxed text-foreground-600">{p.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="reveal mt-14">
          <div className="flex items-end justify-between border-b-2 border-foreground-950 pb-4">
            <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">读者口碑</h3>
            <span className="text-xs text-foreground-500">来自长期使用目录功能的读者</span>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex h-full flex-col rounded-lg border border-background-300 bg-background-100 p-5"
              >
                <i className="ri-double-quotes-l text-2xl text-primary-300"></i>
                <blockquote className="mt-3 flex-1 text-xs leading-relaxed text-foreground-700">
                  {t.text}
                </blockquote>
                <figcaption className="mt-4 flex items-center gap-3 border-t border-background-200 pt-3">
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-secondary-200 font-heading text-xs font-bold text-secondary-800">
                    {t.name.slice(0, 1)}
                  </span>
                  <span>
                    <span className="block text-xs font-semibold text-foreground-950">{t.name}</span>
                    <span className="block text-[11px] text-foreground-500">{t.role}</span>
                  </span>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}